import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PageListItemType } from '../../types';

@Component({
  selector: 'app-pages-list-item',
  templateUrl: './pages-list-item.component.html',
  styleUrls: ['./pages-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagesListItemComponent {
  @Input() page?: PageListItemType;
}
